import React, { useEffect, useState } from 'react'
import { InputItem, Modal } from 'antd-mobile'
import { isNumber, showAlert } from './utils'
import { useIntl } from 'react-intl'

const prompt = Modal.prompt

const SearchInput = ({ type, editable, placeholder, text, searchFn, searchInputVal, children }) => {
  const [inputVal, setInputVal] = useState('')
  const intl = useIntl()

  useEffect(() => {
    if (searchInputVal) setInputVal(searchInputVal)
  }, [searchInputVal])

  const clickInput = () => {
    if (!editable) return
    prompt(intl.formatMessage({ id: 'common-search-title' }), placeholder, [
      { text: intl.formatMessage({ id: 'common-cancel' }) },
      { text: intl.formatMessage({ id: 'common-comfirmBtn' }), onPress: (value) => searchInfo(value) },
    ])
  }

  const searchInfo = (value) => {
    if (!isNumber(value) && type === 'number') {
      showAlert(intl.formatMessage({ id: 'common-search-error' }), intl.formatMessage({ id: 'common-close' }))
      return
    }
    setInputVal(value)
    searchFn(value)
  }

  return (
    <>
      <InputItem
        clear
        editable={editable}
        placeholder={placeholder}
        value={inputVal || ''}
        onClick={() => clickInput()}
      >
        {text}
      </InputItem>
      {children}
    </>
  )
}

export default SearchInput
